import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import './styles.scss'

function appendScript(baseUrl, setScriptLoaded) {
  if (window.MktoForms2) return setScriptLoaded(true)

  const script = document.createElement('script')
  script.src = `${baseUrl}/js/forms2/js/forms2.min.js`
  script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null)
  document.body.appendChild(script)
}

function useMarketo({ baseUrl, munchkinId, formId, setShowSuccess }) {
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [formLoaded, setFormLoaded] = useState(false)

  useEffect(() => {
    if (scriptLoaded) {
      window.MktoForms2.loadForm(baseUrl, munchkinId, formId, (form) => {
        form.onSuccess(function (values, followUpUrl) {
          form.getFormElem().hide()
          setShowSuccess(true)
          return false
        })
      })
    }
    appendScript(baseUrl, setScriptLoaded)
  }, [scriptLoaded, baseUrl, munchkinId, formId, formLoaded])
}

const MarketoBannerForm = ({ formId, successText }) => {
  const [showSuccess, setShowSuccess] = useState(false)
  const baseUrl = '//app-sj31.marketo.com'
  const munchkinId = '850-KKH-319'

  useMarketo({ baseUrl, munchkinId, formId, setShowSuccess })

  return (
    <div>
      <div
        className="marketo-banner-success"
        className={classNames('marketo-banner-success', {
          'active-show': showSuccess,
        })}
      >
        <p className="marketo-banner-success-title">{successText.title}</p>
        <p className="marketo-banner-success-subtitle">
          {successText.subtitle}
        </p>
      </div>
      <form id={`mktoForm_${formId}`}/>
    </div>
  )
}

export default MarketoBannerForm
